var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component-wrapper"},[_c('button',{on:{"click":function($event){$event.preventDefault();return _vm.addCodes.apply(null, arguments)}}},[_vm._v("Add Codes (If you see this, tell Michelle -- Do NOT Click)")])])}
var staticRenderFns = []

export { render, staticRenderFns }